// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3VWGs","content":"styles_content__RolQp","checkbox":"styles_checkbox__1owIq","checkboxLabel":"styles_checkboxLabel__2Y58d"};